import { getFluxApiUrl } from '@utils/utils';
import type { CustomerReviewType } from '@/interfaces/review-types';
import request from '@components/common/services/request';

const initUrl = "/v1/hotel-reviews"

export const get = async(iffCode: number, reviewsPerPage: number, nextUrl: string | null): Promise<CustomerReviewType | null> => {
	let url = nextUrl ?? undefined;
	let data = null; 
	if (!nextUrl) {
		url = initUrl;
		data = {
			'iff_code': iffCode,
			'per-page': reviewsPerPage,
			'page': 1
		};
	}
	const resp = await request<CustomerReviewType>({method: 'get', url, data, baseURL: getFluxApiUrl() }, 'customer-reviews', 3, false)
	if (!resp?.AggregateRating) {
		return null;
	}
	return resp;
};
